import Swiper, { Navigation, Pagination, Lazy, Autoplay } from "swiper";
import { elementScrollIntoView } from "seamless-scroll-polyfill";

Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const productPickerSlider = document.querySelector(".js-product-picker-swiper-init");

if (productPickerSlider) {
    window.addEventListener("load", () => initProductPicker(productPickerSlider));
}

function initProductPicker(productPickerSlider) {
    const slides = productPickerSlider.querySelectorAll(".swiper-slide");
    const allSlidesInputs = productPickerSlider.querySelectorAll(".js-product-picker-card-input");
    const buttonPrev = document.querySelector(".js-product-picker-swiper-controls .swiper-controls__button-prev");
    const buttonNext = document.querySelector(".js-product-picker-swiper-controls .swiper-controls__button-next");
    const buttonSubmit = document.querySelector(".js-product-picker-submit");

    const checkInputs = (inputsSearchTarget) => {
        const inputs = inputsSearchTarget.querySelectorAll(".js-product-picker-card-input");

        return Array.prototype.some.call(inputs, (input) => input.checked);
    };

    const buttonSubmitController = () => {
        const buttonSubmitState = Array.from(allSlidesInputs).some((input) => input.checked);

        if (buttonSubmitState) {
            buttonSubmit.classList.remove("disabled");
        } else {
            buttonSubmit.classList.add("disabled");
        }
    };

    const initProductPickerCardInputsListeners = (currentSlide, target) => {
        const inputsOnCurrentSlide = currentSlide.querySelectorAll(".js-product-picker-card-input");

        inputsOnCurrentSlide.forEach((input) => {
            input.addEventListener("click", () => {
                buttonSubmitController();

                if (checkInputs(currentSlide)) {
                    target.classList.remove("disabled");
                } else {
                    target.classList.add("disabled");
                }
            });
        });
    };

    const swiper = new Swiper(productPickerSlider, {
        lazy: {
            elementClass: "lazyload",
            loadPrevNext: true,
            loadPrevNextAmount: 2,
            loadedClass: "swiper-lazyloaded",
            loadingClass: "swiper-lazyloading",
        },
        allowTouchMove: false,
        shortSwipes: false,
        pagination: {
            el: ".js-product-picker-swiper-controls > .swiper-pagination",
            clickable: true,
        },
        navigation: {
            prevEl: buttonPrev,
            nextEl: buttonNext,
        },
        on: {
            init() {
                if (window.mobileMedia) {
                    setWrapperHeight(slides[0]);
                }

                if (!window.mobileMedia) {
                    productPickerCardInfoMatchHeight(slides);
                }

                if (buttonPrev) {
                    buttonPrev.classList.add("hidden");
                }

                if (buttonNext) {
                    if (!checkInputs(slides[0])) {
                        buttonNext.classList.add("disabled");
                    } else {
                        buttonNext.classList.remove("disabled");
                    }

                    initProductPickerCardInputsListeners(slides[0], buttonNext);
                }

                if (buttonSubmit) {
                    buttonSubmitController();
                }
            },
            slideChange() {
                if (window.mobileMedia) {
                    setWrapperHeight(slides[swiper.realIndex]);
                }

                if (!checkInputs(slides[swiper.realIndex])) {
                    buttonNext.classList.add("disabled");
                } else {
                    buttonNext.classList.remove("disabled");
                }

                initProductPickerCardInputsListeners(slides[swiper.realIndex], buttonNext);

                if (!swiper.isBeginning) {
                    buttonPrev.classList.remove("disabled");
                    buttonPrev.classList.remove("hidden");
                } else {
                    buttonPrev.classList.add("hidden");
                }

                if (swiper.isEnd) {
                    buttonNext.classList.add("hidden");
                } else {
                    buttonNext.classList.remove("hidden");
                }
            },
            slideChangeTransitionEnd() {
                if (window.mobileMedia) {
                    const banner = document.querySelector(".banner");

                    if (banner) {
                        elementScrollIntoView(banner, {
                            behavior: "smooth",
                            block: "start",
                        });
                    }
                }
            },
        },
    });
}

function setWrapperHeight(currentSlide) {
    if (productPickerSlider) {
        const wrapper = productPickerSlider.querySelector(".swiper-wrapper");

        if (wrapper) {
            wrapper.style.height = `${currentSlide.offsetHeight}px`;
        }
    }
}

function productPickerCardInfoMatchHeight(target) {
    target.forEach((item) => {
        const matchHeightTargets = item.querySelectorAll(".js-info-match-height");

        if (matchHeightTargets) {
            let neededHeight = 0;

            for (let i = 0; i < matchHeightTargets.length; i++) {
                if (matchHeightTargets[i].offsetHeight > neededHeight) {
                    neededHeight = matchHeightTargets[i].offsetHeight;
                    i++;
                }
            }

            matchHeightTargets.forEach((item) => {
                item.style.height = `${neededHeight}px`;
            });
        }
    });
}
